module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d51f51f3c6a61a26fa0.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/app/api/search.worker.js
// module id = 1315
// module chunks = 0